// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let DialogResultsStuct = function ()
{
    this.Button = DialogResultsStuct.CallBackInitiator.notSet;
    this.Data = null;
};

DialogResultsStuct.CallBackInitiator =
{
    notSet: -1,
    okClick: 0,
    cancelClick: 1,
    closeClick: 2,
};